module.exports = __webpack_public_path__ + "front-static/media/greenCircle.8b0125862cc0591825cfabec2414aadf.png";